import { useEffect, useRef, useState } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import styles from "./jackpot.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../../helper/common";
import LoaderCstm from "../../../components/Loader";
import useSocket from "../../../hooks/useSocket";
import useNetworkState from "../../../hooks/useNetworkState";
import hex from "../../../assets/images/jackpotHex.png";
import hexglow from "../../../assets/images/jackpotglow.png";
import hexfade from "../../../assets/images/jackpotHexaFade.png";
import hexHalf from "../../../assets/images/jackpotHalfHex.png";
import {
  completeJackpot,
  startJackpot,
  jackpotDetails,
  jackpotAmount,
} from "../../../lib/store/actions";
import CongratulationPop2 from "../../../components/Modals/congratulationPop2";
import CloseJackpotPop from "../../../components/Modals/closeJackpotPop";
import GameOverJackPop from "../../../components/Modals/GameOverJackPop";
import { useGameContext } from "../../../context/GameContext";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const Jackpot = () => {
  // const { t } = useTranslation();
  const t = useLanguage();

  const { playSound } = useGameContext();
  const [congrats2, setCongrats2] = useState(false);
  const [closePop, setClosePop] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [exitConfirmed, setExitConfirmed] = useState(false);
  const { user: userData } = useSelector(({ Auth }) => Auth);
  const { loading } = useSelector(({ Jackpot }) => Jackpot);
  const [isToastActive, setIsToastActive] = useState(false);
  const [forceStopClick, setForceStopClick] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [jackpotCompleted, setJackpotCompleted] = useState(false);
  const [winningCong, setWinningCong] = useState(null);
  const [imageLoadingStates, setImageLoadingStates] = useState({});
  const dispatch = useDispatch();
  const { socket, socketConnect } = useSocket();
  const isClickExecuting = useRef(false);
  const network = useNetworkState();
  const [isLoading, setIsLoading] = useState(false);
  const [jackpot, setJackpot] = useState();
  const navigate = useNavigate();
  const { jackpotAmountDetails } = useSelector(({ Jackpot }) => Jackpot);
  const [isCompleting, setIsCompleting] = useState(false);
  const prevGameOverRef = useRef(false);
  const prevCongrats2Ref = useRef(false);
  const prevClosePopRef = useRef(false);
  const location = useLocation();

  useEffect(() => {
    if (prevGameOverRef.current && !gameOver && !isCompleting) {
      setTimeout(() => navigate("/game"), 300);
    }
    prevGameOverRef.current = gameOver;
  }, [gameOver, isCompleting, navigate]);

  useEffect(() => {
    if (prevCongrats2Ref.current && !congrats2 && !isCompleting) {
      setTimeout(() => navigate("/game"), 300);
    }
    prevCongrats2Ref.current = congrats2;
  }, [congrats2, isCompleting, navigate]);

  useEffect(() => {
    if (prevClosePopRef.current && !closePop) {
      if (exitConfirmed && jackpot) {
        // console.info("exit confirmed", jackpot);
        completeGame(2, jackpot, "closed");
        navigate("/game");
      }
      setExitConfirmed(false);
    }
    prevClosePopRef.current = closePop;
  }, [closePop, exitConfirmed, jackpot]);

  useEffect(() => {
    dispatch(
      jackpotAmount({
        data: {},
        callBack: (err, res) => {
          if (err) return;
        },
      }),
    );
  }, [dispatch]);

  async function getJackpotSocketData(data) {
    return new Promise((resolve) => {
      socket.emit("getJackpotData", data, (res) => {
        if (res?.status) {
          resolve(res);
        } else {
          resolve(null);
        }
      });
    });
  }

  const resetJackpot = () => {
    setJackpot(null);
  };

  const handleImageLoad = (rowIndex, itemIndex) => {
    setImageLoadingStates((prev) => ({
      ...prev,
      [`${rowIndex}-${itemIndex}`]: true,
    }));
  };

  const handleClick = async (rowIndex, colIndex) => {
    try {
      console.info("handle click called ------>", rowIndex, colIndex);
      if (isClickExecuting.current) return;
      isClickExecuting.current = true;

      const keyExists = jackpot.openedBoxes?.some(
        (box) => box.row === rowIndex && box.column === colIndex,
      );
      console.info("keyExists ------>", keyExists);
      if (keyExists) return;

      if (!network?.online) {
        if (!isToastActive) {
          setIsToastActive(true);
          showToast("Please check your internet connection!", "error");
          setTimeout(() => setIsToastActive(false), 3000);
        }
        return;
      }

      if (
        !jackpot?.jackpotID ||
        !socketConnect ||
        !network?.online ||
        forceStopClick ||
        isLoading ||
        !jackpot?._id
      ) {
        isClickExecuting.current = false;
        return;
      }
      setForceStopClick(true);
      const item = await getJackpotSocketData({
        jackpotID: jackpot?.jackpotID,
        row: rowIndex + 1,
        column: colIndex + 1,
      });
      if (!item) return;
      console.info("got jackpot click value ==>");
      const updatedJackpot = { ...jackpot };
      const potData = [...(updatedJackpot.potData || [])];
      const newPotData = potData.map((row) => (row ? [...row] : []));
      if (!newPotData[rowIndex]) newPotData[rowIndex] = [];
      newPotData[rowIndex][colIndex] = {
        ...item?.data?.boxData,
        isOpened: true,
      };
      updatedJackpot.potData = newPotData;
      updatedJackpot.openedBoxes = [
        ...(updatedJackpot.openedBoxes || []),
        {
          row: rowIndex,
          column: colIndex,
        },
      ];
      updatedJackpot.jackpotCount = item?.data?.jackpotCount;
      updatedJackpot.gameOver = item?.data?.gameOver;
      // console.info("updatedJackpot ====>", updatedJackpot);
      setJackpot(updatedJackpot);
      if (item?.data?.boxData) {
        if (item?.data?.boxData?.type === "btnc") {
          playSound("btnc");
        } else if (item?.data?.boxData?.type === "energy") {
          playSound("energy");
        } else if (item?.data?.boxData?.type === "grand") {
          playSound("grandopen");
        } else if (item?.data?.boxData?.type === "major") {
          playSound("majoropen");
        } else if (item?.data?.boxData?.type === "minor") {
          playSound("minoropen");
        }
      }
      if (item?.data?.bombOpened) {
        updatedJackpot.bombOpened = true;
        updatedJackpot.status = "completed";
        updatedJackpot.completedAt = new Date();
        setJackpot(updatedJackpot);
        completeGame(2, updatedJackpot, "bomb");
        playSound("bombendgame");
      } else if (item?.data?.wonJackpot && item?.data?.jackpotType) {
        setWinningCong({
          name: item?.data?.boxData?.type,
          amount: item?.data?.wonAmount,
        });
        completeGame(2, updatedJackpot, "won");
        setTimeout(() => {
          playSound("jackpotopen");
          setCongrats2(true);
        }, [500]);
      } else {
        setForceStopClick(false);
      }
    } catch (err) {
      console.error("Error in handleClick:", err);
    } finally {
      setTimeout(() => {
        isClickExecuting.current = false;
      }, 0);
    }
  };

  const completeGame = async (needToEnd, updatedJackpot, type) => {
    setIsLoading(true);
    setIsCompleting(true);
    try {
      // console.info("claim btnc ----->", type);
      const copyUpdatedJackpot = { ...updatedJackpot };
      dispatch(
        completeJackpot({
          data: {
            _id: copyUpdatedJackpot?._id,
          },
          callBack: (err, res) => {
            if (err?.message === "canceled") return;
            if (err) {
              if (parseInt(err?.status_code) === 406) {
                resetJackpot();
                return;
              }
              return;
            }
            copyUpdatedJackpot.potData = res?.jackpotHistory?.potData || [];
            copyUpdatedJackpot.openedBoxes =
              res?.jackpotHistory?.openedBoxes || [];
            setJackpot(copyUpdatedJackpot);
            setTimeout(() => {
              if (type !== "won") {
                setGameOver(true);
                playSound("jackpotlost");
              }
              setRefresh(!refresh);
            }, [1000]);
            setIsLoading(false);
            setForceStopClick(false);
            setJackpotCompleted(true); // ✅ Mark as completed
          },
        }),
      );
    } catch (err) {
      console.error("Error in completeGame:", err);
      setTimeout(() => setIsLoading(false), 1000);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsCompleting(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (!jackpot) {
      setIsLoading(true);
      if (userData?.currentJackpot) {
        sessionStorage.removeItem("allowNewJackpot");
        dispatch(
          jackpotDetails({
            data: { _id: userData?.currentJackpot },
            callBack: (err, res) => {
              setIsLoading(false);
              if (err?.message === "canceled") return;
              if (err) {
                if (parseInt(err?.status_code) === 406) return;
                return;
              }
              setJackpot(res?.data);
            },
          }),
        );
      } else {
        const allowNewJackpot =
          sessionStorage.getItem("allowNewJackpot") === "true";
        if (allowNewJackpot) {
          sessionStorage.removeItem("allowNewJackpot");
          dispatch(
            startJackpot({
              data: {},
              callBack: (err, res) => {
                setIsLoading(false);
                if (err?.message === "canceled") return;
                if (err) {
                  if (parseInt(err?.status_code) === 403) {
                    showToast("No jackpot entry available", "error");
                  } else if (parseInt(err?.status_code) === 400) {
                    showToast("You already have an active jackpot", "error");
                  } else {
                    showToast("Failed to start jackpot", "error");
                  }
                  navigate("/game");
                  return;
                }
                setJackpot(res?.data);
              },
            }),
          );
        } else {
          // No permission to start new game
          setIsLoading(false);
          showToast("Invalid access", "error");
          navigate("/game");
        }
      }
    }
  }, [userData?.currentJackpot, dispatch, jackpot]);

  // useEffect(() => {
  //   const handleUnload = () => {
  //     if (jackpot && !jackpotCompleted) {
  //       completeGame(2, jackpot, "unload");
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleUnload);
  //   window.addEventListener("unload", handleUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleUnload);
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, [jackpot, jackpotCompleted]);

  // console.info("jackpot =======>", jackpot);

  return (
    <>
      <CongratulationPop2
        congrats2={congrats2}
        setCongrats2={(value) => {
          setCongrats2(value);
          if (!value) {
            setTimeout(() => navigate("/game"), 100);
          }
        }}
        winningData={winningCong}
      />

      <GameOverJackPop
        gameOver={gameOver}
        setGameOver={(value) => {
          setGameOver(value);
          if (!value) {
            setTimeout(() => navigate("/game"), 100);
          }
        }}
      />

      <CloseJackpotPop
        closePop={closePop}
        setClosePop={setClosePop}
        onExitConfirmed={() => setExitConfirmed(true)}
      />

      {(loading || isLoading) && <LoaderCstm />}
      <section className={`${styles.jackpotSec} position-relative `}>
        <Container>
          <Row>
            <Col lg="12" className="my-2 no-minimize">
              <div
                className={`${styles.topHead} top pb-3 text-center position-relative`}
              >
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    setClosePop(true);
                  }}
                  className="border-0 p-0 position-absolute "
                  variant="transparent"
                  style={{ top: 0, left: 10 }}
                >
                  {backIcn}
                </Button>
                <h5 className="m-0 text-white fw-bold">
                  {t("jackpot_page.title")}
                </h5>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Row className={`${styles.typesCardWrpper}`}>
                <Col lg="4" className="my-2 col-4">
                  <div
                    onClick={() => setCongrats2(!congrats2)}
                    className={`${styles.cardCstm} p-2 text-center`}
                  >
                    <h5 className="m-0 fw-bold">{t("jackpot_page.grand")}</h5>
                    <p className="m-0 text-white">
                      $ {jackpotAmountDetails?.grandAmount}
                    </p>
                    <ul className="list-unstyled ps-0 mt-2 mb-0 d-flex align-items-center justify-content-center">
                      {[1, 2, 3].map((index) => (
                        <li
                          key={index}
                          className={`rounded-circle ${
                            jackpot?.jackpotCount?.grand >= index
                              ? styles.active
                              : ""
                          }`}
                        ></li>
                      ))}
                    </ul>
                  </div>
                </Col>
                <Col lg="4" className="my-2 col-4">
                  <div className={`${styles.cardCstm} p-2 text-center`}>
                    <h5 className="m-0 fw-bold">{t("jackpot_page.major")}</h5>
                    <p className="m-0 text-white">
                      $ {jackpotAmountDetails?.majorAmount}
                    </p>
                    <ul className="list-unstyled ps-0 mt-2 mb-0 d-flex align-items-center justify-content-center">
                      {[1, 2, 3].map((index) => (
                        <li
                          key={index}
                          className={`rounded-circle ${
                            jackpot?.jackpotCount?.major >= index
                              ? styles.active
                              : ""
                          }`}
                        ></li>
                      ))}
                    </ul>
                  </div>
                </Col>
                <Col lg="4" className="my-2 col-4">
                  <div className={`${styles.cardCstm} p-2 text-center`}>
                    <h5 className="m-0 fw-bold">{t("jackpot_page.minor")}</h5>
                    <p className="m-0 text-white">
                      $ {jackpotAmountDetails?.minorAmount}
                    </p>
                    <ul className="list-unstyled ps-0 mt-2 mb-0 d-flex align-items-center justify-content-center">
                      {[1, 2, 3].map((index) => (
                        <li
                          key={index}
                          className={`rounded-circle ${
                            jackpot?.jackpotCount?.minor >= index
                              ? styles.active
                              : ""
                          }`}
                        ></li>
                      ))}
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="position-relative overflow-auto"
                style={{ height: "calc(100vh - 120px)" }}
              >
                <ul
                  className={`${styles.hexRow} text-center list-unstyled ps-0 mb-0 overflow-auto`}
                  //   style={{ height: "calc(100vh - 274px)" }}
                >
                  <li
                    className={`${styles.hexCol} d-flex align-items-center position-relative justify-content-center`}
                    style={{
                      marginTop: "-23%",
                      opacity: 0.3,
                      gap: 10,
                    }}
                  >
                    <div className="">
                      <img
                        src={hexHalf}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                    <div
                      className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                    >
                      <img
                        src={hexfade}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                    <div
                      className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                    >
                      <img
                        src={hexfade}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                    <div
                      className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                    >
                      <img
                        src={hexfade}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                    <div className="">
                      <img
                        style={{ transform: "scaleX(-1)" }}
                        src={hexHalf}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                  </li>

                  {jackpot?.potData?.map((row, rowIndex) => (
                    <li
                      key={rowIndex}
                      className={`${styles.hexCol} d-flex align-items-center position-relative justify-content-center`}
                    >
                      {/* Left half hex */}
                      <div>
                        <img
                          src={hexHalf}
                          alt=""
                          className="img-fluid object-fit-contain"
                        />
                      </div>

                      {/* Map inner array */}
                      {row.map((item, itemIndex) => (
                        <div
                          key={itemIndex}
                          className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                          onClick={() => handleClick(rowIndex, itemIndex)}
                        >
                          {item.isOpened ? (
                            <>
                              <img
                                src={hex}
                                alt=""
                                className="img-fluid object-fit-contain"
                              />
                              <img
                                src={hexglow}
                                alt=""
                                className={`${styles.glow} mx-auto img-fluid object-fit-contain position-absolute`}
                              />
                            </>
                          ) : (
                            <img
                              src={hex}
                              alt=""
                              className="img-fluid object-fit-contain"
                              style={{ opacity: 0.5 }}
                            />
                          )}
                          <div
                            className={`${styles.content} content position-absolute mx-auto`}
                          >
                            {(item.isOpened || jackpot.gameOver) && (
                              <>
                                {item.type !== "bomb" &&
                                  item.type !== "btnc" &&
                                  item.type !== "energy" && (
                                    <h6
                                      className="m-0 pb-1 fw-bold text-white"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {item?.type == "major"
                                        ? t("jackpot_page.major")
                                        : item?.type == "minor"
                                          ? t("jackpot_page.minor")
                                          : item?.type == "grand"
                                            ? t("jackpot_page.grand")
                                            : ""}
                                      {/* {item?.type?.toUpperCase()} */}
                                    </h6>
                                  )}
                                {(item.type === "btnc" ||
                                  item.type === "energy") && (
                                  <h6
                                    className="m-0 pb-1 fw-bold text-white"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {item?.value}
                                  </h6>
                                )}
                                <div className="d-flex justify-content-center position-relative">
                                  {!imageLoadingStates[
                                    `${rowIndex}-${itemIndex}`
                                  ] && (
                                    <div
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        background:
                                          "linear-gradient(90deg, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.1) 75%)",
                                        backgroundSize: "200% 100%",
                                        animation: "shimmer 1.5s infinite",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  )}
                                  <img
                                    src={item?.icon}
                                    alt={item?.type}
                                    className="img-fluid object-fit-contain"
                                    onLoad={() =>
                                      handleImageLoad(rowIndex, itemIndex)
                                    }
                                    style={{
                                      display: imageLoadingStates[
                                        `${rowIndex}-${itemIndex}`
                                      ]
                                        ? "block"
                                        : "none",
                                    }}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      ))}

                      {/* Right half hex (mirrored) */}
                      <div>
                        <img
                          src={hexHalf}
                          style={{ transform: "scaleX(-1)" }}
                          alt=""
                          className="img-fluid object-fit-contain"
                        />
                      </div>
                    </li>
                  ))}

                  <li
                    className={`${styles.hexCol} d-flex align-items-center position-relative justify-content-center`}
                    style={{
                      maxHeight: 120,
                      overflow: "hidden",
                      opacity: 0.3,
                      gap: 10,
                    }}
                  >
                    <div className="">
                      <img
                        src={hexHalf}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                    <div
                      className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                    >
                      <img
                        src={hexfade}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                    <div
                      className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                    >
                      <img
                        src={hexfade}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                    <div
                      className={`${styles.innerCol} position-relative d-flex align-items-center flex-column`}
                    >
                      <img
                        src={hexfade}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                    <div className="">
                      <img
                        style={{ transform: "scaleX(-1)" }}
                        src={hexHalf}
                        alt=""
                        className="img-fluid object-fit-contain"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </>
  );
};
export default Jackpot;

const backIcn = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 20"
    fill="none"
  >
    <path
      d="M2.91436 9.76907L12.1877 2.01034C12.4158 1.81953 12.4158 1.5135 12.1877 1.32268C11.9596 1.13186 11.5939 1.13186 11.3658 1.32268L1.67935 9.42704C1.45128 9.61785 1.45128 9.92388 1.67935 10.1147L11.3658 18.2155C11.4777 18.3091 11.6283 18.3595 11.7746 18.3595C11.9209 18.3595 12.0715 18.3127 12.1834 18.2155C12.4115 18.0246 12.4115 17.7186 12.1834 17.5278L2.91436 9.76907Z"
      fill="white"
      stroke="white"
      stroke-width="2.26051"
    />
  </svg>
);
